import { useState,useEffect } from "react";
import { apiCall } from "../../components/service/api-service";
import moment from "moment";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";

import ticketIcon from "../../assets/svg/ticket-day.svg"
import subTicketIcon from "../../assets/svg/sub-ticket-icon.svg";
import calendarIcon from "../../assets/svg/calendar.svg";
 const CalendarDateViewModal = ({selectedDate,listingType,onHide }) => {
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          padding: "16px 24px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "688px",
          height:"425px",
          textAlign: "center",
         /*  overflowY: "auto", */
        },
      };


 const [loading, setLoading] = useState(false);
 const [dayTicketCount, setDayTicketCount] = useState(null);
 const [dayTicketList, setDayTicketList] = useState([/* {
  "id": 92,
  "title": "Something went wrong",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Closed",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 90,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 89,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 88,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 87,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 86,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 85,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
},
{
  "id": 84,
  "title": "Custom Component Ticket",
  "is_sub": false,
  "team_name": "Avengers",
  "status": "Open",
  "date": "25 Feb 2025 - 25 Feb 2025"
} */]);
 
 const [statusType, setStatusType] = useState('All');
 const activeTab={height:'36px', padding:'4px 12px', borderRadius:'8px', background:'#6929E2', color:'#FFFFFF',};
 const inActiveTab={height:'36px',padding:'4px 12px', borderRadius:'8px',border:'0.7px solid #E5E5E5', background:'#FFFFFF', color:'#212129'};
   useEffect(() => {getStatusTicketListing()},[statusType])
 
  const getStatusTicketListing = async () => {
  setLoading(true);
  setDayTicketList([]);
    try {
        const response = await apiCall("GET", "ticket_calendar_detail", null, {
          params: {
            type: listingType,
            from_date: "",
            to_date: "",
            search: "",
            status: statusType,
            date: selectedDate,
          },
        });

        if (response?.data?.success === true) {
          setDayTicketCount(response.data.count);
          setDayTicketList(response.data.tickets);
        }
       
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
};
    
   
         
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{display: "flex", flexDirection:'column', alignItems:'start'}}>
 <div
      style={{
        paddingLeft: "4px",
        fontSize: "20px",
        fontWeight: "500",
        color: "#212129",
      }}
    >
    {moment(new Date(selectedDate)).format("dddd, DD MMM YYYY")} 
    </div>
    <div
      style={{
        paddingLeft: "4px",
        fontSize: "20px",
        fontWeight: "400",
       color:'#98A1B0'
      }}
    >
     {/*  {ticketDetail.title??''} */}
    </div>
    </div>
            

              <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onHide}
              />
            </div>

            <div style={{ marginTop: "8px" }}>
            <div className="mb-3" style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'12px',lineHeight:'16.2px',color:'#8790A1',textAlign:'left'}}>{dayTicketCount?.total??0} tickets </div>
            <div  className=" d-flex justify-content-center justify-content-lg-start gap-8">
        <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('All')}} style={statusType==='All'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>All  ({dayTicketCount?.total??0})</div>
         </div>
         <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('Open')}} style={statusType==='Open'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>Open ({dayTicketCount?.open??0})</div>
         </div>
         <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('In Progress')}} style={statusType==='In Progress'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>In Progress ({dayTicketCount?.in_progress??0})</div>
         </div>
         <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('Hold')}} style={statusType==='Hold'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>Hold ({dayTicketCount?.hold??0})</div>
         </div>  
         <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('Closed')}} style={statusType==='Closed'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>Closed ({dayTicketCount?.closed??0})</div>
         </div> 
         <div className="d-flex align-items-center mx-1" onClick={()=>{setStatusType('Completed')}} style={statusType==='Completed'?activeTab:inActiveTab}>
                  <div style={{fontSize:'12px', fontWeight:'600'}}>Completed ({dayTicketCount?.completed??0}) </div>
         </div>
              </div>
             <div  style={{height:'270px',overflowY:'scroll'}} >
              <div className="mt-3">
              {dayTicketList.length>0 && dayTicketList.map((item, index) => ( 
                <div key={'ticket-list-'+index} className="mb-2 " style={{ borderRadius:'16px', background:'#F7F8F9',padding:'16px'}}>
                  <div className="d-flex justify-content-start">
                    <div style={{width:'32px', height:'32px'}}>
                    <img src={ticketIcon} />
                      </div>
                      <div style={{paddingLeft:'8px',textAlign:'left' }}>
                      <span style={{textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",fontFamily:'Satoshi',fontWeight:'500',fontSize:'13px',lineHeight:'17.55px',color:'#212129'}}>{item.code}  {item.title} {item.is_sub===true && (<img src={subTicketIcon} style={{ width:'16px', height:'16px', marginLeft:'8px', marginTop:'-5px'  }}/>)} </span>
                      <div style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'12px',lineHeight:'16.2px',color:'#8790A1'}}>{item.team_name} <span className="mx-1" style={{width:'4px', height:'4px', borderRadius:'100px', background:'#D9D9D9'}}></span>  <span style={{fontFamily:'Satoshi',fontWeight:'700',fontSize:'12px',lineHeight:'16.2px',color:'#6929E2'}}>{item.status}</span></div>
                        <div><img src={calendarIcon} /> <span style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'11px',color:'#212129',}}>{item.date}</span></div>
                      </div>
                    </div>
                </div>
               ))}
               </div>
               </div>
            </div>
          </div>
        </div>
      </div>);

}

export default CalendarDateViewModal;